import { ModelNameEnum } from '@bit-by-bit-software/types';
import { Airtable, Classy, Component, Data, Email } from '../interact';

/**
  This will handle all API calls so they are not randomly made throughout the application
*/
class ApiManager {
  /* eslint-disable-next-line no-use-before-define */
  static #singleton: ApiManager | null = null;

  #apiToken: string | null = null;

  /**
      Initializer so we can get an API token
     */
  static Init(apiToken: string | null = null) {
    // Initialize and load styles
    if (ApiManager.#singleton == null) {
      ApiManager.#singleton = new ApiManager();
    }
    if (apiToken !== null) {
      ApiManager.#singleton.#apiToken = apiToken;
    }
    return ApiManager.#singleton;
  }

  static GetInstance() {
    return this.#singleton;
  }

  /**
      Interact with a route (social|data) and perform action (like|report|create|delete|update)
      @note   Params come in as params object
      @param  {String}  route   (social|data)
      @param  {String}  action  (like|dislike) (create|delete|update)
      @param  {JSON}  params  Params of request
    */
  static async SendRequest<EXTRA, T = any>(params: {
    route: 'airtable' | 'classy' | 'component' | 'data' | 'email' | 'user';
    action: string;
    params?: any;
    model?: ModelNameEnum;
    apiToken?: string;
    id?: string;
  }): Promise<{ results?: T } & EXTRA & { error?: string }> {
    if (params.route === 'airtable') {
      // @ts-ignore
      return Airtable.Interact(params, params.apiToken ?? ApiManager.#singleton.#apiToken);
    }
    if (params.route === 'classy') {
      // @ts-ignore
      return Classy.Interact(params, params.apiToken ?? ApiManager.#singleton.#apiToken);
    }
    if (params.route === 'component') {
      // @ts-ignore
      return Component.Interact(params, params.apiToken ?? ApiManager.#singleton.#apiToken);
    }
    if (params.route === 'data') {
      // @ts-ignore
      return Data.Interact(params, params.apiToken ?? ApiManager.#singleton.#apiToken);
    }
    if (params.route === 'email') {
      // @ts-ignore
      return Email.Interact(params, params.apiToken ?? ApiManager.#singleton.#apiToken);
    }

    throw new Error('Unrecognized route');
  }
}

export default ApiManager;
